export default "__VITE_ASSET__BpzFCDuQ__"